namespace SolovisGateway.Admin.EnvironmentPools {

    export class EnvironmentPoolEditorControl extends Solovis.UI.BaseControl {

        private _environmentPoolId;
        private _isDirty;

        private _initErrorText;
        private _environmentPoolEditModel;        

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;

        public _savedEnvironmentPoolEditorModel;

        constructor(options) {
            super(options);

            this._environmentPoolId = options.environmentPoolId ? options.environmentPoolId : null;

            this._isDirty = false;
        }

        public doInitAsync() {
            var self = this;

            Solovis.Rpc.invoke("~/Admin/EnvironmentPoolAdmin/GetEditEnvironmentPoolDialogInitialState",
                { id: this._environmentPoolId },
                function (response, success) {

                    if (success) {
                        if (!response.result.environmentPoolEditModel) {
                            self._initErrorText = "Failed to retrieve environment pool edit model.";
                        }
                        else {
                            self._environmentPoolEditModel = response.result.environmentPoolEditModel;
                        }
                        self.notifyInitComplete();
                    }
                    else {
                        self._initErrorText = response.error.message;
                        self.notifyInitComplete();
                    }
                });
        }

      
        public doRender() {
            var self = this;
           
            if (this._initErrorText) {
                this.container.text(this._initErrorText);
                return;
            }

            var formDiv = $("<div>").appendTo(this.container);
            var formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formDiv
            });

            // Name
            formBuilder.addEntry({
                name: "name",
                label: "Name",

                initialValue: this._environmentPoolEditModel.name ? this._environmentPoolEditModel.name : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        required: true,
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // CloudServiceDomain
            formBuilder.addEntry({
                name: "cloudServiceDomain",
                label: "Cloud Service Domain",

                initialValue: this._environmentPoolEditModel.cloudServiceDomain ? this._environmentPoolEditModel.cloudServiceDomain : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });            

            // Redis Cache Connection String
            formBuilder.addEntry({
                name: "redisCacheConnectionString",
                label: "Redis Cache Connection String",

                initialValue: this._environmentPoolEditModel.redisCacheConnectionString ? this._environmentPoolEditModel.redisCacheConnectionString : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControls.TextAreaInputControl({
                        container: createEditorOptions.container,
                        width: 400,
                        rows: 3,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        cssRules: {
                            "resize": "both"
                        }
                    });

                    return editorControl;
                }
            });



            formBuilder.setupDone();

            $(formBuilder).bind("valueChanged", function () {
                self._isDirty = true;
            });

            this._formBuilder = formBuilder;
        }


        public _getEnvironmentPoolModel() {
            var name = this._formBuilder.getValueByName("name");
            var cloudServiceDomain = this._formBuilder.getValueByName("cloudServiceDomain");            
            var redisCacheConnectionString = this._formBuilder.getValueByName("redisCacheConnectionString");

            var model = {
                name: name,
                cloudServiceDomain: cloudServiceDomain,                
                redisCacheConnectionString: redisCacheConnectionString,
                environmentPoolId: this._environmentPoolId

            };

            return model;
        }


        public hideEditFields() {
            this._formBuilder.showEntries(false);
        }


        /*
         * options:
         * success -    true or false
         *              If success is true, this function assumes that a property called _savedDataEnvironmentEditorModel
         *              was set.  _savedDataEnvironmentEditorModel should contain the modelResult of the serverside save call.
         *              If success is false, then an error message should be provided.
         * message -    Error message to display on the form.
         */
        public notify(options) {
            var self = this;

            if (options.success) {

                this.hideEditFields();

                var successHtml = $("<div>");

                var name = this._formBuilder.getValueByName("name");

                var environmentPoolLink = $("<a>")
                    .text(name)
                    .attr("href", Solovis.resolveUrl("~/Admin/EnvironmentPoolAdmin/Info/?poolId=" + this._savedEnvironmentPoolEditorModel.environmentPoolId))
                    .appendTo(successHtml);

                successHtml
                    .prepend("Environment Pool ")
                    .append(" saved.");

                var state = {
                    success: {
                        html: successHtml
                    }
                };

                this._formBuilder.formValidationModel.state(state);
            }
            else {
                this._formBuilder.formValidationModel.setErrorMessage(options.message);
            }
        }


        public isDirty() {
            return this._isDirty;
        }

        public isValid() {
            return !this._formBuilder.hasErrors();
        }
    }

}
